import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	list: []
};

export default function keywords(state = initialState, action) {
	
	switch (action.type) {			

		case "IS_FETCHING":
			return update(state, { isFetching: { $set: action.bool } });

		case "SET_KEYWORDS_LIST":
			return update(state, { list: { $set: action.keywords } });		

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/domains/keywords/reducer.js